export const noop = () => undefined;

export const pipe = (...functions: Array<(...args: any[]) => any>) =>
  (data: any) => functions.reduce((value, func) => func(value), data);

export function deferredValue<T>(valueFn: () => T) {
  // tslint:disable-next-line:space-before-function-paren
  const generator = (function* () {
    const value = valueFn();
    while (true) {
      yield value;
    }
  })();

  return () => generator.next().value;
}

export function exceptionToMessage(ex: any): string {
  return typeof ex === 'string' ? ex : JSON.stringify(ex, errorJsonReplacer);
}

function errorJsonReplacer(key: any, value: any) {
  return value instanceof Error ? value.toString() : value;
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/shared/util.ts